<template>
  <!-- 应用bottomcolor作为背景颜色，添加渐变效果 -->
  <div class="page-container" :style="{
    'color': textColor
  }" >
    <!-- 背景图片层 -->
    <div class="background-layer" :style="{ 'background-image': `url(${backgroundImageUrl})` }"></div>

    <!-- 用户登录/信息区域 - 更现代化的设计 -->
    <div class="user-area">
      <div class="user-info-box" v-if="isLoggedIn">
        <div class="user-avatar-wrapper" @click="showDropdown = !showDropdown">
          <el-avatar :size="45" :src="userInfo.face" class="user-avatar" />
          <div class="user-badge">
            <el-icon>
              <StarFilled />
            </el-icon>
          </div>
        </div>

        <transition name="el-zoom-in-top">
          <div v-if="showDropdown" class="user-dropdown-menu">
            <div class="dropdown-header">
              <el-avatar :size="52" :src="userInfo.face" class="dropdown-avatar" />
              <div class="user-details">
                <h3>{{ userInfo.uname }}</h3>
                <p class="user-id">UID: {{ userInfo.mid }}</p>
                <p class="user-integral">积分: {{ settingData.Integral }}</p>
              </div>
            </div>

            <div class="dropdown-divider"></div>

            <div class="dropdown-item" @click="logout2">
              <el-icon>
                <SwitchButton />
              </el-icon>
              <span>退出登录</span>
            </div>
          </div>
        </transition>
      </div>

      <div class="login-entry" v-else>
        <el-button type="primary" size="small" @click="goToLogin" :icon="User" class="login-button">
          登录
        </el-button>
      </div>
    </div>

    <!-- 导航栏 - 玻璃拟态设计 -->
    <nav class="navbar">
      <ul class="nav-list">
        <li class="nav-item" v-for="item in navItems" :key="item.path" :class="{ 'active': isActive(item.path) }">
          <router-link :to="item.path"
            :style="{ 'background-color': settingData.Navigationcolor || 'rgba(0, 0, 0, 0.7)' }">
            <el-icon :size="18" class="nav-icon">
              <component :is="item.icon" />
            </el-icon>
            <span>{{ item.name }}</span>
          </router-link>
        </li>
      </ul>
    </nav>

    <!-- 主内容区域 - 卡片玻璃拟态效果 -->
    <div class="link-integral-container" :style="{ '--theme-color': settingData.color || '#ffffff' }">
      <el-card class="main-card glass-effect" shadow="hover" :style="{ 'background-color': cardBackgroundColor }">
        <template #header>
          <div class="header-title">
            <el-icon class="title-icon">
              <Link />
            </el-icon>
            <span>{{ settingData.nickname }}的虚拟空间</span>
          </div>
        </template>

        <!-- 礼物一览区域 -->
        <div class="gift-container">
          <!-- <el-page-header content="虚拟空间" icon="" title="礼物一览" class="page-header" /> -->

          <el-table :data="tableDate" style="width: 100%" class="custom-table" v-loading="loading">
            <el-table-column prop="datatime" label="日期" width="100" align="center" />
            <el-table-column prop="title" label="标题" min-width="150" />
            <el-table-column label="内容" min-width="150">
              <template #default="scope">
                <el-tooltip :content="scope.row.content" placement="top" effect="light">
                  <div class="content-ellipsis">{{ scope.row.content }}</div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="舰长填写表" width="100" align="center">
              <template #default="scope">
                <el-button type="primary" plain size="small" @click="handleJump(scope.row.address_1, 3)"
                  :disabled="!scope.row.address_1">
                  舰长填写表
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="提督填写表" width="100" align="center">
              <template #default="scope">
                <el-button type="success" plain size="small" @click="handleJump(scope.row.address_2, 2)"
                  :disabled="!scope.row.address_2">
                  提督填写表
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="总督填写表" width="100" align="center">
              <template #default="scope">
                <el-button type="danger" plain size="small" @click="handleJump(scope.row.address_3, 1)"
                  :disabled="!scope.row.address_3">
                  总督填写表
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template #default="scope">
                <el-tooltip content="查看详情" placement="top">
                  <el-button :icon="Search" circle size="small" @click="handleLook(scope.row)" />
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 礼物一览对话框 - 美化版 -->
      </el-card>
    </div>
  </div>

  <div class="dialog-fixed-wrapper" v-if="dialogVisible">
    <el-dialog v-model="dialogVisible" title="礼物详情" width="80%" top="5vh" custom-class="stable-detail-dialog"
      :modal="false" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false"
      :lock-scroll="false">
      <div class="preview-container">
        <div class="dialog-content">
          <el-card shadow="hover">
            <div class="preview-header">
              <div class="preview-field">
                <el-icon>
                  <Calendar />
                </el-icon>
                <span>日期：</span>
                <strong>{{ previewData.datatime }}</strong>
              </div>
              <div class="preview-field">
                <el-icon>
                  <Document />
                </el-icon>
                <span>标题：</span>
                <strong>{{ previewData.title }}</strong>
              </div>
            </div>

            <el-divider>
              <el-icon>
                <Star />
              </el-icon>
            </el-divider>

            <div class="preview-field">
              <el-icon>
                <Notebook />
              </el-icon>
              <span>内容：</span>
              <p class="preview-content">{{ previewData.content }}</p>
            </div>

            <el-divider>
              <el-icon>
                <Picture />
              </el-icon> 礼物展示
            </el-divider>

            <div class="image-grid">
              <el-image v-if="previewData.image_1" :src="ASSET_BASE + previewData.image_1"
                :preview-src-list="getPreviewImages()" fit="cover" class="gift-image scale-on-hover">
                <template #error>
                  <div class="image-error">
                    <el-icon :size="24">
                      <Picture />
                    </el-icon>
                  </div>
                </template>
              </el-image>

              <el-image v-if="previewData.image_2" :src="ASSET_BASE + previewData.image_2"
                :preview-src-list="getPreviewImages()" fit="cover" class="gift-image scale-on-hover">
                <template #error>
                  <div class="image-error">
                    <el-icon :size="24">
                      <Picture />
                    </el-icon>
                  </div>
                </template>
              </el-image>

              <!-- 继续添加 image_3 到 image_5 -->
              <el-image v-if="previewData.image_3" :src="ASSET_BASE + previewData.image_3"
                :preview-src-list="getPreviewImages()" fit="cover" class="gift-image scale-on-hover">
                <template #error>
                  <div class="image-error">
                    <el-icon :size="24">
                      <Picture />
                    </el-icon>
                  </div>
                </template>
              </el-image>

              <el-image v-if="previewData.image_4" :src="ASSET_BASE + previewData.image_4"
                :preview-src-list="getPreviewImages()" fit="cover" class="gift-image scale-on-hover">
                <template #error>
                  <div class="image-error">
                    <el-icon :size="24">
                      <Picture />
                    </el-icon>
                  </div>
                </template>
              </el-image>

              <el-image v-if="previewData.image_5" :src="ASSET_BASE + previewData.image_5"
                :preview-src-list="getPreviewImages()" fit="cover" class="gift-image scale-on-hover">
                <template #error>
                  <div class="image-error">
                    <el-icon :size="24">
                      <Picture />
                    </el-icon>
                  </div>
                </template>
              </el-image>
            </div>
          </el-card>
        </div>
      </div>

      <template #footer>
        <el-button type="primary" @click="dialogVisible = false">关闭预览</el-button>
      </template>
    </el-dialog>
  </div>



  <div class="floating-button-container">
    <el-tooltip content="反馈" placement="left">
      <el-button class="floating-button" type="primary" circle :style="{ width: '56px', height: '56px' }"
        @click="handleClick">
        <el-icon size="30">
          <Service />
        </el-icon>
      </el-button>
    </el-tooltip>
  </div>

  <!-- 反馈表单对话框 -->
  <el-dialog v-model="floatingVisible" title="用户反馈" width="500px" custom-class="feedback-dialog"
    :close-on-click-modal="false">
    <el-form :model="feedbackForm" :rules="feedbackRules" ref="feedbackFormRef" label-width="100px">
      <el-form-item label="你的B站UID" prop="userId">
        <el-input v-model="feedbackForm.userId" placeholder="请输入你的用户ID"></el-input>
      </el-form-item>

      <el-form-item label="问题类型" prop="problemType">
        <el-select v-model="feedbackForm.problemType" placeholder="请选择问题类型">
          <el-option label="加群审核" value="加群审核"></el-option>
          <el-option label="禁言申诉" value="禁言申诉"></el-option>
          <el-option label="私信补发" value="私信补发"></el-option>
          <el-option label="音声礼物" value="音声礼物"></el-option>
          <el-option label="物流相关" value="物流相关"></el-option>
          <el-option label="其他" value="其他"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="问题描述" prop="problemDesc">
        <el-input v-model="feedbackForm.problemDesc" type="textarea" :rows="4" placeholder="请详细描述你的问题..."></el-input>
      </el-form-item>

      <el-form-item label="QQ联系方式" prop="contactInfo">
        <el-input v-model="feedbackForm.contactInfo" placeholder="请留下联系方式以便回复"></el-input>
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="floatingVisible = false">取消</el-button>
        <el-button type="primary" @click="submitFeedback">提交反馈</el-button>
      </span>
    </template>
  </el-dialog>

    <!-- 在template部分的最后，floating-button-container之后添加备案号 -->
  <div class="footer-record">
    <div class="record-text" :style="{ 'color': textColor }">
      <a href="https://beian.miit.gov.cn/" target="_blank" :style="{ 'color': textColor }">
        陕ICP备2025066285号-2
      </a>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed, onUnmounted } from 'vue';
import { ElMessage } from 'element-plus';
import {
  Link, Search, User, StarFilled, SwitchButton, Picture, Service,
  HomeFilled, Calendar, Collection, Present, Headset, InfoFilled, Coin
} from '@element-plus/icons-vue';
import axios from 'axios';
import { useRoute, useRouter } from 'vue-router';
import { ASSET_BASE } from '../../util/assetBase';

const route = useRoute();
const router = useRouter();
const backgroundImageUrl = ref('');
// 导航项配置
const navItems = [
  { path: '/', name: '首页', icon: HomeFilled },
  { path: '/works', name: '作品', icon: Collection },
  { path: '/points', name: '积分兑换', icon: Coin },
  { path: '/captain', name: '舰长礼物', icon: Present },
  { path: '/songlist', name: '歌单', icon: Headset },
  { path: '/about', name: '关于', icon: InfoFilled }
];

// 判断当前路由是否激活
const isActive = (path) => {
  return route.path === path;
};

// 计算文本颜色基于背景色
const textColor = computed(() => {
  const bgColor = settingData.bottomcolor || '#000000';
  // 简单计算背景亮度决定文字颜色
  const color = bgColor.replace('#', '');
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 128 ? '#333' : '#fff';
});

// 计算卡片背景颜色
const cardBackgroundColor = computed(() => {
  const bgColor = settingData.backcolor || 'rgba(255, 255, 255, 0.9)';
  if (bgColor.includes('rgba')) {
    // 如果是rgba，增加透明度
    return bgColor.replace(/[\d\.]+\)$/, '0.85)');
  }
  return bgColor;
});

// 用户信息
const isLoggedIn = ref(false);
const userInfo = reactive({
  uname: '',
  mid: '',
  face: ''
});
const showDropdown = ref(false);

// 点击空白处关闭下拉菜单
const handleClickOutside = (event) => {
  const userArea = document.querySelector('.user-area');
  if (userArea && !userArea.contains(event.target)) {
    showDropdown.value = false;
  }
};

// 检查登录状态
const checkLoginStatus = () => {
  const savedUserInfo = localStorage.getItem('userInfo');
  if (savedUserInfo) {
    try {
      const parsedInfo = JSON.parse(savedUserInfo);
      if (parsedInfo.mid) {
        Object.assign(userInfo, parsedInfo);
        isLoggedIn.value = true;
      }
    } catch (e) {
      console.error('解析用户信息失败:', e);
      localStorage.removeItem('userInfo');
    }
  }
};

// 登录跳转
const goToLogin = () => {
  router.push('/user/login');
};

// 退出登录
const logout = async () => {
  try {
    localStorage.removeItem('userInfo');
    isLoggedIn.value = false;
    userInfo.uname = '';
    userInfo.mid = '';
    userInfo.face = '';
    showDropdown.value = false;
    settingData.Integral = 0;

    if (route.path.startsWith('/user')) {
      router.push('/');
    }
    ElMessage({
      message: '请前往登录使用该功能',
      type: 'warning',
      offset: 20,
      duration: 3000,
      customClass: 'slide-in-left-message'
    });

  } catch (error) {
    console.error('退出登录失败:', error);
  }
};

// 获取用户积分
const UserIntegral = async (usermid) => {
  try {
    const response = await axios.post('/adminapi/userapi/integral/check', {
      uid: usermid
    });
    settingData.Integral = response.data.results[0]?.integral || 0;
  } catch (error) {
    console.error('查询积分失败:', error);
    settingData.Integral = 0;
  }
}

// 获取用户信息
const fetchUserInfo = async () => {
  try {
    const response = await axios.get('/adminapi/user/Bmsg', {
      withCredentials: true
    });

    if (response.data.code === 0 && response.data.data) {
      const userData = response.data.data;
      userInfo.uname = userData.uname || '';
      userInfo.mid = userData.mid || '';
      userInfo.face = await setBilibiliAvatar(userData.face);
      isLoggedIn.value = true;
      UserIntegral(userInfo.mid);

      localStorage.setItem('userInfo', JSON.stringify({
        uname: userInfo.uname,
        mid: userInfo.mid,
        face: userInfo.face
      }));
      fetchUserInfojz();
    } else {
      console.error("获取用户信息失败:", response.data.message);
      logout();
    }
  } catch (error) {
    console.error('请求用户信息失败:', error);
    logout();
  }
};

const setBilibiliAvatar = async (str) => {
  try {
    const response = await axios.post('/adminapi/user/avater', {
      face: str,
    }, {
      responseType: 'arraybuffer',
      withCredentials: true
    });

    const base64 = btoa(
      new Uint8Array(response.data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        ''
      )
    );

    return `data:image/jpeg;base64,${base64}`;
  } catch (error) {
    console.error('获取头像失败:', error);
    return '/default-avatar.png';
  }
}

// 主播信息数据
const settingData = reactive({
  nickname: '',
  slogan: '',
  homepageImage: '',
  color: '#ffffff',
  backcolor: 'rgba(255, 255, 255, 0.85)',
  Navigationcolor: 'rgba(0, 0, 0, 0.7)',
  bottomcolor: '#000000',
  Integral: 0
});
// 表单数据
const urlForm = reactive({
  Live_streaming_room: '',
  Home_Page: '',
  afd: ''
});
// 礼物列表数据
const loading = ref(false);
const dialogVisible = ref(false);
const tableDate = ref([]);
const previewData = ref({});

// 获取主播信息和背景图片
const fetchSettingData = async () => {
  try {
    const [urlResponse, settingResponse] = await Promise.all([
      axios.get('/adminapi/userapi/url/list'),
      axios.get('/adminapi/setting/list'),
    ]);

    const urlData = urlResponse.data.results[0] || {};
    const settingDataRes = settingResponse.data.results[0] || {};

    urlForm.Live_streaming_room = urlData.Live_streaming_room || '';
    urlForm.Home_Page = urlData.Home_Page || '';
    urlForm.afd = urlData.afd || '';

    settingData.nickname = settingDataRes.title || '';
    settingData.slogan = settingDataRes.content || '';
    settingData.homepageImage = settingDataRes.homepageImage || '';
    settingData.color = settingDataRes.color || '#000000';
    settingData.backcolor = settingDataRes.backcolor || 'rgba(255, 255, 255, 0.9)';
    settingData.Navigationcolor = settingDataRes.Navigationcolor || 'rgba(0, 0, 0, 0.7)';
    settingData.bottomcolor = settingDataRes.bottomcolor || '#000000';
    console.log(settingDataRes.page)
    const defaultBackground = 'https://s.panlai.com/zb_users/upload/2025/05/20250506082830174649131053424.jpg';
    backgroundImageUrl.value = settingDataRes.page ? ASSET_BASE + settingDataRes.page : defaultBackground;
    // 设置背景图片
  } catch (error) {
    console.error('加载数据错误:', error);
  }
};

// 获取礼物列表数据
const fetchPrescriptionList = async () => {
  loading.value = true;
  try {
    const res = await axios.get('/adminapi/gift/list');
    tableDate.value = res.data.results || [];
  } catch (error) {
    console.error('获取礼物列表失败:', error);
    ElMessage.error('获取礼物列表失败');
  } finally {
    loading.value = false;
  }
};
//ElMessage.warning('未设置跳转链接');
var resultstr
const fetchUserInfojz = async () => {
  // console.log(uid)
  try {
    const response = await axios.get('/adminapi/user/captain', {//用户信息
      withCredentials: true
    });

    const filteredRooms = response.data.data.list
    // 调用函数
    resultstr = checkMemberExpiry(urlForm.Live_streaming_room, filteredRooms);
    // 输出结果（无匹配舰长记录时 resultstr 为 null，需先判空）
    if (resultstr && resultstr.exists) {
      // ElMessage.warning(`会员 ${resultstr.username} 的等级为 ${resultstr.guardLevel},会员状态：${resultstr.isExpired ? '已过期' : '未过期'}`);
      if (resultstr.guardLevel === 3 && !resultstr.isExpired) {
        ElMessage.success('欢迎回家舰长大人')
      }
      if (resultstr.guardLevel === 2 && !resultstr.isExpired) {
        ElMessage.success('欢迎回家提督大人')
      }
      if (resultstr.guardLevel === 1 && !resultstr.isExpired) {
        ElMessage.success('欢迎回家总督大人')
      }
    } else {
      console.error(result.message);
    }
  } catch (error) {
    console.error('请求用户信息失败:', error);
  }
};
// 判断会员是否过期并获取等级
const checkMemberExpiry = (username, filteredRooms) => {
  // 查找匹配的会员记录
  console.log(username, filteredRooms)
  const targetMember = filteredRooms.find(member => member.room_id === Number(username));

  if (!targetMember) {
    ElMessage.warning('你还没有成为舰长哦~')
    console.error('数据错误');
    return null
  }

  // 转换过期时间为Date对象
  const expiryDate = new Date(targetMember.expired_time);
  const currentDate = new Date();

  // 判断是否过期
  const isExpired = currentDate > expiryDate;

  return {
    exists: true,
    isExpired,
    guardLevel: targetMember.guard_level,
    username: targetMember.rusername,
    expiryDate: targetMember.expired_date
  };
};



// 查看礼物详情
const handleLook = (data) => {
  dialogVisible.value = true;
  previewData.value = data;
  console.log(previewData.value)
};

// 获取预览图片列表
const getPreviewImages = () => {
  const images = [];
  for (let i = 1; i <= 5; i++) {
    if (previewData.value[`image_${i}`]) {
      images.push(ASSET_BASE + previewData.value[`image_${i}`]);
    }
  }
  return images;
};

// 跳转到填写表
const handleJump = (url, num) => {
  if (!userInfo.uname) {
    ElMessage({
      message: '请前往登录使用该功能',
      type: 'warning',
      offset: 20,
      duration: 3000,
      customClass: 'slide-in-left-message'
    });
    return
  }
  console.log(resultstr?.isExpired, resultstr?.guardLevel)
  // 无舰长记录（resultstr 为 null）时不能读属性，直接提示无权限
  if (resultstr && resultstr.guardLevel === num && !resultstr.isExpired) {
    window.open(url, '_blank');
  } else {
    ElMessage.warning('你没有填写权限哦~')
  }
};

onMounted(() => {
  checkLoginStatus();
  fetchUserInfo();
  fetchSettingData();
  fetchPrescriptionList();
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});
const logout2 = async () => {
  try {
    localStorage.removeItem('userInfo');
    isLoggedIn.value = false;
    userInfo.uname = '';
    userInfo.mid = '';
    userInfo.face = '';
    showDropdown.value = false;
    settingData.Integral = 0;

    if (route.path.startsWith('/user')) {
      router.push('/');
    }
    ElMessage.success('已退出登录');
  } catch (error) {
    console.error('退出登录失败:', error);
  }
};
// 点击事件处理
const floatingVisible = ref(false);
// 反馈表单数据
const feedbackForm = reactive({
  userId: '',
  problemType: '',
  problemDesc: '',
  contactInfo: '',
  time: '',
  Solve: '未解决',
  id: ''
});
const generateId = () => {
  // 方法1: 使用时间戳和随机数生成唯一ID
  const timestamp = Date.now().toString(36)
  const random = Math.random().toString(36).substr(2, 5)
  var nameid = `${timestamp}${random}`
  return nameid

}
const feedbackFormRef = ref(null);
const feedbackRules = reactive({
  userId: [{ required: true, message: '请输入你的B站UID', trigger: 'blur' }],
  problemType: [{ required: true, message: '请选择问题类型', trigger: 'change' }],
  problemDesc: [{ required: true, message: '请描述你的问题', trigger: 'blur' }],
  contactInfo: [{ required: true, message: '请留下联系方式', trigger: 'blur' }]
});
const handleClick = () => {
  console.log('反馈按钮被点击')
  floatingVisible.value = true
}
const submitFeedback = async () => {
  // 表单声明了 :rules 却从不校验，空字段会直接写进 Feedback 表
  if (feedbackFormRef.value) {
    try {
      await feedbackFormRef.value.validate();
    } catch (e) {
      return; // 校验不通过，字段下方已有提示
    }
  }
  feedbackForm.time = formatTime(Date.now())
  feedbackForm.id = generateId()
  try {
    var response = await axios.post('/adminapi/Feedback/add', feedbackForm)
    if (response.data && response.data.code === 200) {
      floatingVisible.value = false
      ElMessage.success('反馈成功');
      resetFeedbackForm()
    } else {
      floatingVisible.value = false
      ElMessage.error((response.data && response.data.message) || '反馈失败');
    }
  } catch (error) {
    console.error('反馈提交失败:', error)
    floatingVisible.value = false
    ElMessage.error('反馈失败，请稍后重试');
  }
}
const formatTime = (time) => {
  const date = new Date(time);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day} ${hour}:${minute}`;
};
const resetFeedbackForm = () => {
  feedbackForm.userId = '';
  feedbackForm.problemType = '';
  feedbackForm.problemDesc = '';
  feedbackForm.contactInfo = '';
  feedbackForm.time = '';
  feedbackForm.Solve = '未解决';
  feedbackForm.id = '';
};
</script>

<style lang="scss" scoped>
/* 基础样式 */
:root {
  --glass-blur: 8px;
  --glass-border: 1px solid rgba(255, 255, 255, 0.18);
  --glass-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.page-container {
  min-height: 100vh;
  padding: 20px;
  position: relative;
  background: none !important;
  /* 移除任何背景设置 */
}

.page-container::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  opacity: 0.1;
  z-index: -1;
  /* 使用CSS变量动态设置背景图片 */
  background-image: var(--bg-image, url('https://s.panlai.com/zb_users/upload/2025/05/20250506082830174649131053424.jpg'));
}

.page-container.has-bg-image {
  background-image: url('');
  /* 这里通过JS动态设置 */
}

/* 用户区域样式 - 更现代化的设计 */
.user-area {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 100;

  .user-info-box {
    position: relative;

    .user-avatar-wrapper {
      position: relative;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.05);

        .user-badge {
          transform: translate(30%, -30%) scale(1.2);
        }
      }

      .user-avatar {
        border: 2px solid rgba(255, 255, 255, 0.8);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        transition: all 0.3s ease;
      }

      .user-badge {
        position: absolute;
        top: 0;
        right: 0;
        background: linear-gradient(135deg, #ff4081, #7b1fa2);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 12px;
        transform: translate(30%, -30%);
        transition: transform 0.3s ease;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        z-index: 1;

        .el-icon {
          width: 12px;
          height: 12px;
        }
      }
    }

    .user-dropdown-menu {
      position: absolute;
      top: 60px;
      right: 0;
      width: 260px;
      background: rgba(255, 255, 255, 0.95);
      border-radius: 12px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
      overflow: hidden;
      z-index: 200;
      backdrop-filter: blur(var(--glass-blur));
      border: var(--glass-border);

      .dropdown-header {
        padding: 20px;
        display: flex;
        background: linear-gradient(135deg, rgba(245, 247, 250, 0.8), rgba(228, 231, 235, 0.8));
        border-bottom: 1px solid rgba(238, 238, 238, 0.5);

        .dropdown-avatar {
          margin-right: 15px;
          border: 3px solid white;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }

        .user-details {
          flex: 1;

          h3 {
            margin: 0 0 5px;
            color: #333;
            font-weight: 600;
            font-size: 16px;
          }

          .user-id {
            margin: 0;
            color: #666;
            font-size: 12px;
          }

          .user-integral {
            margin: 5px 0 0;
            color: #e6a23c;
            font-size: 14px;
            font-weight: bold;
          }
        }
      }

      .dropdown-divider {
        height: 1px;
        background: rgba(238, 238, 238, 0.5);
        margin: 0 15px;
      }

      .dropdown-item {
        padding: 12px 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #666;
        font-weight: 500;
        transition: all 0.2s ease;

        &:hover {
          background: rgba(245, 247, 250, 0.8);
          color: #ff4081;

          .el-icon {
            color: #ff4081;
          }
        }

        .el-icon {
          margin-right: 10px;
          font-size: 16px;
          color: #777;
          transition: color 0.2s ease;
        }
      }
    }
  }
}

.login-entry {
  .login-button {
    background: linear-gradient(135deg, #6a11cb, #2575fc);
    border: none;
    border-radius: 20px;
    padding: 8px 20px;
    box-shadow: 0 4px 10px rgba(37, 117, 252, 0.3);
    transition: all 0.3s ease;
    font-weight: 500;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 12px rgba(37, 117, 252, 0.4);

      .el-icon {
        transform: translateX(3px);
      }
    }

    .el-icon {
      transition: transform 0.3s ease;
    }
  }
}

/* 导航栏样式 - 玻璃拟态设计 */
.navbar {
  position: relative;
  z-index: 1;
  margin-bottom: 30px;
  backdrop-filter: blur(var(--glass-blur));

  .nav-list {
    display: flex;
    justify-content: center;
    list-style: none;
    padding: 0;
    margin: 0;
    flex-wrap: wrap;
    gap: 10px;
  }

  .nav-item {
    a {
      color: white;
      text-decoration: none;
      font-size: 15px;
      padding: 10px 18px;
      border-radius: 20px;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      backdrop-filter: blur(var(--glass-blur));
      border: var(--glass-border);

      &:hover {
        opacity: 0.9;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      }

      &.router-link-active {
        box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
        font-weight: bold;
      }

      .nav-icon {
        margin-right: 8px;
      }
    }
  }
}

/* 玻璃拟态效果 */
.glass-effect {
  backdrop-filter: blur(var(--glass-blur));
  border: var(--glass-border) !important;
  box-shadow: var(--glass-shadow) !important;
  background: rgba(255, 255, 255, 0.85) !important;
}

.link-integral-container {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;

  .main-card {
    border-radius: 16px !important;
    overflow: hidden;
    transition: all 0.3s ease;
    min-height: 600px;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15) !important;
    }
  }

  .header-title {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: var(--theme-color);
    padding: 10px 0;

    .title-icon {
      margin-right: 10px;
      color: var(--theme-color);
      font-size: 20px;
    }
  }
}

/* 礼物管理区域样式 */
.gift-container {
  padding: 20px;

  .page-header {
    margin-bottom: 20px;

    :deep(.el-page-header__content) {
      color: var(--theme-color);
    }
  }

  .custom-table {
    --el-table-border-color: rgba(0, 0, 0, 0.08);
    --el-table-header-bg-color: #f8fafc;
    --el-table-row-hover-bg-color: #f5f7fa;

    th {
      font-weight: 600;
      background-color: var(--el-table-header-bg-color) !important;
    }

    .content-ellipsis {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 200px;
    }
  }
}

/* 详情对话框样式 */
.detail-dialog {
  border-radius: 16px !important;

  .el-dialog__header {
    border-bottom: 1px solid #eee;
    margin-right: 0;
  }

  .el-dialog__title {
    font-weight: 600;
    color: #333;
  }

  .gift-detail {
    .detail-header {
      margin-bottom: 20px;

      .detail-date {
        color: #666;
        margin-bottom: 10px;
      }

      .detail-title {
        color: #333;
        margin-bottom: 15px;
      }

      .detail-content {
        color: #555;
        line-height: 1.6;
      }
    }

    .gift-images {
      .images-title {
        color: #333;
        margin-bottom: 15px;
      }

      .image-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        gap: 15px;

        .gift-image {
          width: 100%;
          height: 150px;
          border-radius: 8px;
          cursor: pointer;
          transition: transform 0.3s ease;

          &:hover {
            transform: scale(1.03);
          }
        }

        .image-error {
          width: 100%;
          height: 150px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #f5f7fa;
          border-radius: 8px;
          color: #c0c4cc;
        }
      }
    }
  }

  .dialog-close-btn {
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: 500;
  }
}

/* 响应式调整 */
@media (max-width: 992px) {
  .gift-container .custom-table {
    .content-ellipsis {
      max-width: 150px;
    }
  }
}

@media (max-width: 768px) {
  .page-container {
    padding: 15px;
  }

  .user-area {
    top: 15px;
    right: 15px;

    .user-info-box .user-dropdown-menu {
      width: 240px;
    }
  }

  .navbar {
    margin-bottom: 20px;

    .nav-list {
      gap: 8px;
    }

    .nav-item a {
      padding: 8px 15px;
      font-size: 14px;
    }
  }

  .gift-container {
    padding: 15px;

    .custom-table {
      min-width: 700px;
      overflow-x: auto;
      display: block;
    }
  }
}

@media (max-width: 480px) {
  .user-area {
    .login-entry .login-button {
      padding: 6px 15px;
      font-size: 13px;
    }

    .user-info-box .user-dropdown-menu {
      width: 220px;
    }
  }

  .navbar .nav-item a {
    padding: 6px 12px;
    font-size: 13px;

    .nav-icon {
      margin-right: 5px;
    }
  }

  .gift-images .image-grid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)) !important;
  }
}
</style>
<style lang="scss" scoped>
/* 基础样式变量 */
:root {
  --glass-blur: 12px;
  --glass-bg: rgba(255, 255, 255, 0.85);
  --glass-border: 1px solid rgba(255, 255, 255, 0.2);
  --glass-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  --transition-time: 0.3s;
  --header-decoration-height: 4px;
}

/* 美化后的详情对话框 */
.beautified-detail-dialog {
  .el-dialog {
    border-radius: 16px !important;
    overflow: hidden;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
    }
  }

  .el-dialog__header {
    background: var(--glass-bg);
    backdrop-filter: blur(var(--glass-blur));
    border-bottom: var(--glass-border);
    padding: 20px 30px;
    transition: all var(--transition-time) ease;

    .el-dialog__title {
      font-size: 18px;
      font-weight: 600;
      color: #333;
      display: flex;
      align-items: center;

      .el-icon {
        margin-right: 10px;
        color: var(--theme-color);
      }
    }
  }

  .dialog-header-decoration {
    height: var(--header-decoration-height);
    margin-bottom: 20px;
    background: linear-gradient(90deg, #409eff, #67c23a);
    /* 可自定义渐变色 */
  }

  .gift-detail-wrapper {
    padding: 0 30px 30px;
  }

  .gift-detail-content {
    &>*:not(:last-child) {
      margin-bottom: 30px;
    }
  }

  /* 玻璃卡片样式 */
  .glass-card {
    background: var(--glass-bg);
    backdrop-filter: blur(var(--glass-blur));
    border: var(--glass-border);
    border-radius: 12px;
    padding: 25px;
    box-shadow: var(--glass-shadow);
    transition: all var(--transition-time) ease;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 15px 35px rgba(0, 0, 0, 0.18);
    }
  }

  .info-header,
  .info-title-row,
  .info-content-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 15px;

    .info-icon {
      color: var(--theme-color);
      font-size: 20px;
      margin-right: 15px;
      min-width: 30px;
      text-align: center;
    }
  }

  .info-divider {
    height: 1px;
    background: linear-gradient(to right, transparent, rgba(0, 0, 0, 0.1), transparent);
    margin: 15px 0;
  }

  .detail-date {
    font-size: 18px;
    color: #555;
    font-weight: 500;
  }

  .detail-title {
    font-size: 22px;
    color: #333;
    font-weight: 600;
  }

  .detail-content {
    color: #666;
    line-height: 1.7;
    background-color: rgba(245, 247, 250, 0.5);
    padding: 15px;
    border-radius: 8px;
    font-size: 15px;
  }

  /* 图片展示区域样式 */
  .gift-images-section {
    .section-header {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .section-icon {
        color: var(--theme-color);
        font-size: 20px;
        margin-right: 10px;
      }
    }

    .image-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
      gap: 20px;

      .gift-image {
        width: 100%;
        height: 180px;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        transition: all var(--transition-time) ease;

        &.scale-on-hover:hover {
          transform: translateY(-5px) scale(1.03);
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
        }

        .el-image__error {
          background-color: rgba(245, 247, 250, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;

          .image-error {
            color: #909399;
            font-size: 18px;
          }
        }
      }
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: center;
    padding: 20px 0;
    background: var(--glass-bg);
    backdrop-filter: blur(var(--glass-blur));
    border-top: var(--glass-border);
  }

  .dialog-close-btn {
    padding: 10px 25px;
    border-radius: 8px;
    font-weight: 500;
    display: flex;
    align-items: center;
    transition: all var(--transition-time) ease;

    .el-icon {
      margin-right: 8px;
      font-size: 16px;
    }

    &:hover {
      background-color: var(--theme-color);
      color: white;
      transform: translateY(-2px);
    }
  }

  /* 响应式调整 */
  @media (max-width: 1024px) {
    .beautified-detail-dialog .el-dialog {
      width: 90% !important;
    }

    .gift-detail-wrapper {
      padding: 0 20px 20px;
    }

    .image-grid {
      grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)) !important;
    }
  }

  @media (max-width: 768px) {
    .detail-title {
      font-size: 20px;
    }

    .image-grid {
      grid-template-columns: repeat(auto-fill, minmax(140px, 1fr)) !important;

      .gift-image {
        height: 140px;
      }
    }
  }

  @media (max-width: 480px) {
    .beautified-detail-dialog .el-dialog {
      width: 95% !important;
    }

    .gift-basic-info {
      padding: 20px 15px;
    }

    .detail-date {
      font-size: 16px;
    }

    .detail-title {
      font-size: 18px;
    }

    .image-grid {
      grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)) !important;

      .gift-image {
        height: 120px;
      }
    }
  }
}
</style>
<style scoped>
.page-header {
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.gift-table-card {
  border-radius: 10px;
  margin: 0 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.gift-table-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}

.content-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
}

.action-buttons-group {
  display: flex;
  gap: 8px;
}

.preview-container {
  padding: 10px;
}

.preview-header {
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  margin-bottom: 20px;
}

.preview-field {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  color: #666;
}

.preview-field .el-icon {
  font-size: 18px;
  color: #409eff;
}

.preview-content {
  background-color: #f9f9f9;
  padding: 15px;
  border-radius: 6px;
  line-height: 1.6;
  margin-top: 10px;
  color: #333;
  font-size: 15px;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 15px;
  margin-top: 20px;
}

.image-preview {
  height: 150px;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.image-preview:hover {
  transform: translateY(-3px);
}

.image-preview .el-image {
  width: 100%;
  height: 100%;
}

.image-upload-item {
  margin-bottom: 20px;
}

.upload-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.3s;
}

.upload-icon:hover {
  border-color: #409eff;
}

.image-container {
  position: relative;
  width: 120px;
  height: 120px;
  overflow: hidden;
  border-radius: 6px;
}

.uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
  cursor: pointer;
}

.image-container:hover .image-overlay {
  opacity: 1;
}

.image-overlay .el-icon {
  color: white;
  font-size: 20px;
}

@media (max-width: 768px) {
  .preview-header {
    flex-direction: column;
    gap: 15px;
  }

  .action-buttons-group {
    justify-content: center;
  }

  .gift-table-card {
    margin: 0 10px;
  }
}

/* 防止弹窗闪烁的样式 */
.beautified-detail-dialog {
  position: fixed;
  z-index: 2000 !important;
  /* 确保高于其他元素 */
  pointer-events: auto;

  .el-dialog__wrapper {
    backdrop-filter: none !important;
    background-color: transparent !important;
  }

  .el-dialog {
    pointer-events: all;
    transform: none !important;
    transition: none !important;
  }

  .el-dialog__header {
    pointer-events: all;
  }

  .el-dialog__body {
    pointer-events: all;
  }
}

/* 防止弹窗闪烁的样式 */
.dialog-fixed-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  pointer-events: auto;
}

/* 稳定的弹窗样式 */
.stable-detail-dialog {
  position: static !important;
  transform: none !important;
  transition: none !important;
  margin: 0;

  .el-dialog {
    position: relative !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
    margin: 0;
    max-height: 90vh;
    overflow-y: auto;
  }

  .el-dialog__header,
  .el-dialog__body,
  .el-dialog__footer {
    position: relative;
    z-index: 1;
  }
}

/* 禁用所有不必要的过渡动画 */
.stable-detail-dialog * {
  transition: none !important;
  animation: none !important;
}

/* 防止滚动穿透 */
body.dialog-open {
  overflow: hidden;
  position: fixed;
  width: 100%;
}

/* 全屏弹窗样式 */
.fullscreen-dialog-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
}

/* 背景遮罩 */
.dialog-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1;
}

/* 弹窗内容容器 */
.dialog-container {
  position: relative;
  z-index: 2;
  width: 80%;
  max-width: 1000px;
  max-height: 90vh;
  background: white;
  border-radius: 12px;
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 弹窗头部 */
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: #f8f8f8;
  border-bottom: 1px solid #eee;
}

.dialog-header h2 {
  margin: 0;
  font-size: 20px;
  color: #333;
}

.close-button {
  font-size: 18px;
  color: #999;
  padding: 0;
}

.close-button:hover {
  color: #666;
}

/* 弹窗内容区域 */
.dialog-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

/* 预览内容容器 */
.preview-container {
  padding: 10px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .dialog-container {
    width: 95%;
    max-height: 95vh;
  }
}

:global(.stable-detail-dialog *) {
  transition: none !important;
  animation: none !important;
}

.floating-button-container {
  display: flex;
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 1000;
}

.floating-button {

  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  background-color: #409EFF;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  width: 56px;
  height: 56px;

  &:hover {
    transform: scale(1.08);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
  }

  &:active {
    transform: scale(0.95);
  }
}
.background-layer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  z-index: -1;
  /* 确保在内容层下方 */
  /* filter: brightness(0.7); */
  /* 适当降低亮度增加可读性 */

  /* 如果需要覆盖渐变效果 */

}
/* 在style部分添加备案号样式 */
.footer-record {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 10;
  padding: 8px 0;
  backdrop-filter: blur(8px);
  background-color: rgba(0, 0, 0, 0.2);
  
  .record-text {
    font-size: 12px;
    letter-spacing: 0.5px;
    
    a {
      text-decoration: none;
      transition: opacity 0.3s;
      
      &:hover {
        opacity: 0.8;
        text-decoration: underline;
      }
    }
  }
}
</style>


<style>
/* 全局样式 - 自定义消息提示位置和动画 */
.slide-in-left-message {
  left: 6% !important;
  right: auto !important;
  animation: slideInFromLeft 0.4s ease-out !important;
}

@keyframes slideInFromLeft {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
